import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type CustomerNodeFragment = { __typename?: 'CustomerNode', id: string, address?: string | null, additionalAddress?: string | null, city?: string | null, zip?: number | null, standingOrderLimit?: number | null, country?: string | null, phone?: string | null, additionalPhone?: string | null, email?: string | null, fax?: string | null, additionalFax?: string | null, bankAccountNumber?: string | null, branchNumber?: string | null, name: string, oldNumber?: number | null, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, companyNumber?: string | null, contactName?: string | null, shouldUnionInvoices: boolean, bank?: { __typename?: 'BankNode', name: string } | null };

export const CustomerNodeFragmentDoc = gql`
    fragment CustomerNode on CustomerNode {
  id
  address
  additionalAddress
  city
  zip
  standingOrderLimit
  country
  phone
  additionalPhone
  email
  fax
  additionalFax
  bankAccountNumber
  branchNumber
  name
  bank {
    name
  }
  oldNumber
  type
  title
  companyNumber
  contactName
  shouldUnionInvoices
}
    `;